import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { useOpenActiveGame } from '@swf/poker';

import type { Props as EmbeddedGameProps } from './useOpenEmbeddedGame';
import useOpenEmbeddedGame from './useOpenEmbeddedGame';
import usePublicClubsFeatureHandler from './usePublicClubsFeatureHandler';
import usePublicClubsRestricted from './usePublicClubsRestricted';

interface Props extends EmbeddedGameProps {
  tableUrl?: string;
  unsupported?: boolean;
}

const useOpenGame = ({ tableUrl, unsupported, clubId, id, link }: Props) => {
  const isEmbedded = useSelector(select.device.isEmbedded);
  const handleEmbeddedGame = useOpenEmbeddedGame({ id, clubId, link });
  const openActiveGame = useOpenActiveGame({ tableUrl });

  const openGame = () => {
    if (unsupported || !tableUrl) return;

    if (isEmbedded) {
      handleEmbeddedGame();
    } else {
      openActiveGame();
    }
  };

  const { showClubRestrictedToast } = usePublicClubsRestricted();
  const { validatePublicClubVisibility } = usePublicClubsFeatureHandler(
    clubId,
    openGame,
    showClubRestrictedToast
  );

  return validatePublicClubVisibility;
};

export default useOpenGame;
